import type { Vector3 } from "three";
import { create } from "zustand";

import { useLayoutStore } from "./layout.store.js";

export type ContextMenuType = "table" | "avatar";

interface ContextMenuTableContent {
  type: "table";
  channelUuid: string;
  displayName: string;
  tableId: string;
}

interface ContextMenuAvatarContent {
  type: "avatar";
  userId: string;
}

type ContextMenuContent = ContextMenuTableContent | ContextMenuAvatarContent;

interface ScreenPosition {
  x: number;
  y: number;
  isVisible: boolean;
}

interface ContextMenuState {
  show: boolean;
  worldPosition: Vector3 | null;
  screenPosition: ScreenPosition | null;
  content: ContextMenuContent | null;
}

interface ContextMenuActions {
  showContextMenu: (params: {
    worldPosition: Vector3;
    content: ContextMenuContent;
  }) => void;
  hideContextMenu: () => void;
  setScreenPosition: (pos: ScreenPosition) => void;
}

export type ContextMenuStore = ContextMenuState & ContextMenuActions;

export const useContextMenuStore = create<ContextMenuStore>((set) => ({
  content: null,

  hideContextMenu: () => {
    set({
      content: null,
      screenPosition: null,
      show: false,
      worldPosition: null,
    });
  },
  screenPosition: null,

  setScreenPosition: (pos) => {
    set({ screenPosition: pos });
  },
  show: false,

  showContextMenu: ({ worldPosition, content }) => {
    useLayoutStore.getState().closeAvatarMenu();
    set({ content, show: true, worldPosition });
  },
  worldPosition: null,
}));
